import { UPDATE_NB_SLOTS_PASSED } from "./nbOfSlotsPassedReducer"

export const updateNbOfSlotsPassed = (nb) => ({
    type: UPDATE_NB_SLOTS_PASSED,
    payload: nb
})